// sort-imports-ignore
import React from 'react';

import { createRoot } from 'react-dom/client';

// prettier-disable
import './assets/scss/main-theme.scss';
import { App } from './root';
// prettier-disable
import { UiProvider } from 'ui';

import * as Sentry from '@sentry/react';

// Only init Sentry when an environment is set
if (import.meta.env.VITE_SENTRY_ENVIRONMENT) {
  Sentry.init({
    dsn: 'https://ce5b813d425f06c5fa96846d04124e34@o395617.ingest.us.sentry.io/4508429811843072',
    integrations: [],
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    // Only enable Sentry in non-development environments
    enabled: import.meta.env.VITE_SENTRY_ENVIRONMENT !== 'development',
  });
}
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <UiProvider
      theme={{
        components: {
          Modal: {
            defaultProps: {
              yOffset: 'var(--safe-area-top, 5dvh)',
            },
          },
        },
      }}
    >
      <App />
    </UiProvider>
  </React.StrictMode>
);
